import { styled } from '@mui/material';
import { PADDING, SPACES } from '../../../../constants/sizes';
import {
  StyledOrgDetails,
  StyledOrgDetailsName,
} from '../OrgDetails/OrgDetails.style';

export const StyledOrgsSelector = styled.div`
  & ${StyledOrgDetails} {
    cursor: pointer;
    padding: ${SPACES['x-small']} ${SPACES['normal']};

    & ${StyledOrgDetailsName} {
      cursor: pointer;
    }
  }

  > div:nth-of-type(2) {
    margin-top: ${PADDING['x-x-medium']};
  }

  > :last-child {
    margin-bottom: ${PADDING['x-medium']};
  }
`;
